(function () {
  'use strict';

  angular
    .module('web2print')
    .config(tmhDynamic)
    .config(config);

  /** @ngInject */
  function config ($httpProvider, $localStorageProvider, $locationProvider, $sessionStorageProvider, $translateProvider,
    $provide) {

    //Config Authorization Header for all requests to Orders
    $httpProvider.interceptors.push(function (authFactory, $localStorage, $location) {
      return {
        request: function (config) {
          if (authFactory.checkSessionExpiry($localStorage.productDelivery)) {
            $localStorage.pageBeforeLogin = $location.$$path;
            pnTopbar.login();
            return;
          }
          // Only add header if request to specific services below
          if (config.url.indexOf(web2print.env.ordersBaseUrl) !== -1 ||
            config.url.indexOf(web2print.env.validCustomerNumbersUrl) !== -1) {
            let token = null;

            // Get token from top bar if available
            if (typeof (pnTopbar) !== 'undefined') {
              token = pnTopbar.access_token || 'anonymous';
            } else { // Get from localstorage if top bar was not present
              token = 'anonymous';
            }

            if (token === '') {
              token = null;
            } // Do not allow empty string

            config.headers.Authorization = String(token); // Always send a non-empty string
          }
          return config;
        }
      };
    });

    // Config router
    $locationProvider.html5Mode(false);

    // Config storage
    const country = 'se'; //CommonProvider.$get().getServiceCountry(); //FIXME, calling CommonProvider causes issues with $sessionStorage. Feels like the key prefix does not get set at all for reading, only writing. Weird.
    $localStorageProvider.setKeyPrefix(country.toLowerCase() + '-web2print-');
    $sessionStorageProvider.setKeyPrefix(country.toLowerCase() + '-web2print-');

    // Config translations
    $translateProvider.useStaticFilesLoader({
      prefix: web2print.env.translationsPrefix,
      suffix: '.json'
    }).determinePreferredLanguage();

    if (web2print.env.stage !== 'prod') {
      $translateProvider.translations('zu', {});
    }

    $translateProvider.useSanitizeValueStrategy('escapeParameters');

    const language = $translateProvider.preferredLanguage();

    if (language.indexOf('en') === -1 && language.indexOf('sv') === -1) {
      console.log('Unimplemented language: ' + language + '. Setting default language en');

      $translateProvider.preferredLanguage('en');
    } else if (language.indexOf('en') !== -1) {
      $translateProvider.preferredLanguage('en');
    } else if (language.indexOf('sv') !== -1) {
      $translateProvider.preferredLanguage('sv');
    }
    console.log('Using language: ' + $translateProvider.preferredLanguage());

    if (typeof (pnTopbar) !== 'undefined') {
      if (web2print.env.stage === 'prod') {

        pnTopbar.languages = [{
          key: 'sv',
          name: 'Svenska'
        },
        {
          key: 'en',
          name: 'English'
        }
        ];
      } else {
        pnTopbar.languages = [{
          key: 'sv',
          name: 'Svenska'
        },
        {
          key: 'en',
          name: 'English'
        },
        {
          key: 'da',
          name: 'Dansk'
        },
        {
          key: 'zu',
          name: 'Zulu'
        }
        ];
      }


      let implementedLanguage = false;
      pnTopbar.languages.forEach(function (language) {
        implementedLanguage = implementedLanguage || language.key === pnTopbar.language;
      });

      if (!implementedLanguage) {
        pnTopbar.language = 'en';
      }

      $translateProvider.preferredLanguage(pnTopbar.language);
    }

    // for datepicker dynamic language
    $provide.decorator('uibDatepickerDirective', function ($delegate) {
      angular.forEach($delegate, function (directive) {
        const originalCompile = directive.compile;
        const originalLink = directive.link;

        if (originalCompile) {
          directive.compile = function () {
            return function (scope, el, attr, ctrl) {
              scope.$on('$localeChangeSuccess', function () {
                scope.move(0);
              });

              scope.$watch('activeDateId', function () {
                scope.$emit('checkYear', (scope.activeDt || {}).date || new Date());
              });

              scope.$on('datepickerRefreshView', function () {
                ctrl[0].refreshView();
              });

              originalLink.apply(this, arguments);
            };
          };
        }
      });

      return $delegate;
    });
  }

  function tmhDynamic (tmhDynamicLocaleProvider) {
    tmhDynamicLocaleProvider.localeLocationPattern('assets/translations/angular-locale_{{locale}}.js');
  }

})();
